import React from 'react'
import DropdownItem from '../../components/dropdown-item/dropdownItem'
import save from './images/save.svg';
import cancel from './images/cancel.svg';
import Button from '../../components/form-elements/button';
import PropTypes from 'prop-types';
import AuthenticationService from '../../services/authentication-service';
import CartService from '../../services/cart-service';
import Messages from '../../constants/Messages';

const Dropdown = ({values, setIsLocationModal = () => {}, setSelectedValues = () => {}, locationData = {}, setUserLocation = () => {}}) => {
  const styles = {text: 'text-rose-700 text-md', background: `flex items-center p-2 gap-3 cursor-pointer hover:bg-rose-50 hover:rounded`};
  function saveLocationValues() {
    if(locationData.prevLocation !== locationData.userLocation) {
      setSelectedValues({selectedLocation: locationData.userLocation});
      setIsLocationModal(false);
      AuthenticationService.setEventDetails(locationData.userLocation);
      CartService.clearCart();
    } else {
      setIsLocationModal(false);
    }
  }
  function cancelLocationValues() {
    setSelectedValues({selectedLocation: locationData.prevLocation});
    setIsLocationModal(false);
  }
  return (
    <div className='absolute right-9 top-14 px-1 pb-3 bg-white rounded-lg drop-shadow-lg flex flex-col items-center justify-center'>
        <ul className='flex flex-col my-2'>
          {
            values.map((value) => {
              return <DropdownItem image={require(`./images/${value.location_name.toLowerCase()}.svg`)} key={value.location_id} value={value.location_name} className={styles} setSelectedValues={setSelectedValues} setUserLocation={setUserLocation}/>
            })
          }
        </ul>
        <div className='flex items-center justify-between gap-2 mx-2'>
            <Button size={'small'} color={'secondary'} onClick={saveLocationValues}><p>{Messages.SHOP.LOCATION.ACTION.SAVE}</p><img src={save} className='h-2'/></Button>
            <Button size={'small'} color={'tertiary'} onClick={cancelLocationValues}><p>{Messages.SHOP.LOCATION.ACTION.CANCEL}</p><img src={cancel} className='h-2'/></Button>
        </div>
    </div>
  )
}

Dropdown.propTypes = {
    setIsLocationModal: PropTypes.func,
    setSelectedValues: PropTypes.func
}

export default Dropdown